<template>
 <v-dialog v-model="dialogApprove" max-width="500px" persistent max-height="500px" style="overflow-y: hidden;">
  <v-card style="border-radius:20px;">
      <v-toolbar card style="background: white !important;">
        <v-toolbar-title class="CSChatThai" style="color: #2562ae !important;"> {{ApproveDetail.info_ans[0].title}}</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn dark icon flat @click="closeDialog">
          <v-icon style="color: #2562ae !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text  style="padding: 10px; padding-top: 5px; padding-left: 0px;" v-if="ApproveDetail.disable === 'false'">
        <v-container wrap style="padding-top:  0px;">
          <v-layout align-center justify-center wrap>
            <v-flex sm12 md12 xs12 style="display: flex; justify-content: center;" v-if="ApproveDetail.info_ans[0].image">
              <img  :src="ApproveDetail.info_ans[0].image" class="alligator-turtle" style="height: 20vh;">
            </v-flex>
            <v-flex sm12 md12 xs12>
              <p>{{$t('Dialog.approve.detail')}} : </p>
            </v-flex>
            <v-flex sm12 md12 xs12>
              <v-container style="height: 20vh; margin-top: 0; width: 90%;padding: 0;" class="scroll-y CSChatThai">
                <p v-html="ApproveDetail.info_ans[0].detail.replace(/(?:\r\n|\r|\n)/g, '<br>')">
                </p>
                <!-- {{ApproveDetail}} -->
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-text  style="padding: 10px; padding-top: 5px; padding-left: 0px;" v-else>
        <div style="text-align: center;">
        <v-icon style="color: #757575 !important; font-size: 80px !important;">error_outline</v-icon>
         <br><br>
          <p style="font-size: 17px; color: #757575;"> {{$t('Dialog.approve.answer')}} </p>
        </div>
      </v-card-text>
      <v-card-actions v-if="ApproveDetail.disable === 'false'">
        <!-- <v-spacer></v-spacer> -->
        <v-layout align-center justify-center wrap row style="margin-left: 30px;">
          <div v-for="(item, index) in ApproveDetail.info_ans[0].choice" style="margin-left: 15px;">
            <v-flex xs6 sm6 md6 v-if="item.type=='cancel'">
              <v-layout row wrap align-center justify-center>
                <v-btn small color="red" flat @click="sendansApprove(item)"  style="text-transform: none; border: 1px solid; border-radius: 15px;">{{item.label}}</v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs6 sm6 md6 v-else>
              <v-layout row wrap align-center justify-center>
                <v-btn small color="primary" flat @click="sendansApprove(item)"  style="text-transform: none; border: 1px solid; border-radius: 15px;">{{item.label}}</v-btn>
              </v-layout>
            </v-flex>
          </div>
        </v-layout>
      </v-card-actions>
  </v-card>
</v-dialog>
</template>
<script>
export default {
  props: {dialogApprove: false, ApproveDetail: {}},
  data: () => ({
  }),
  watch: {
    socketdisableapprove (data) {
      if (data.tokenroom === this.$route.params.roomid && data.tokenmessage === this.ApproveDetail.tokenmessage) {
        this.ApproveDetail.disable = 'true'
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeApprove', false)
    },
    sendansApprove (item) {
      this.$emit('sendansApprove', item, this.ApproveDetail.tokenmessage)
      this.closeDialog()
    }
  }
}
</script>
<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/mobile/dialog/ApproveDialogMobile.vue